import {
  Box,
  IconButton,
  InputAdornment,
  InputBase,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"
import { SearchIcon, CloseIcon as CrossIcon } from "components/icons"

import { SearchBasePopup } from "components/domains/search/SearchBasePopup"
import { SearchResult } from "components/domains/search/SearchResult"

import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace"
import { SearchKeyboard } from "./SearchKeyboard"

export const SearchPopupContent = ({
  openSearchState,
  reset,
  popupType,
  onChange,
  onChangeKeyboard,
  onSelectResult,
  searchResultItems,
  searchInputRef,
  showOnscreenKeyboard,
  searchValue,
  inputProps = {},
  closeButtonProps = {},
  closeIconProps = {},
  searchBasePopupProps = {},
  closeIcon: CloseIcon = KeyboardBackspaceIcon,
  searchKeyboardProps = {},
  searchResultProps = {},
  clearSearchValue,
}) => {
  const { sx: closeButtonSxProps } = closeButtonProps
  const { sx: closeIconSxProps } = closeIconProps
  const { sx: inputSxProps } = inputProps
  const { t } = useTranslation({ defaultValue: null })

  // Theme & Styling
  const theme = useTheme()
  const searchBarStyles =
    theme.components[`VuiSearchPopupContent`]?.styleOverrides || {}

  return (
    <SearchBasePopup
      {...searchBasePopupProps}
      open={openSearchState}
      onClose={reset}
      type={popupType}
    >
      {/* SearchBar */}
      <Box
        sx={searchBarStyles.root}
        className={`popupType-${popupType} VuiSearchPopupContent-searchBar`}
      >
        <IconButton
          {...closeButtonProps}
          className="VuiSearchPopupContent-closeButton"
          sx={deepmerge(searchBarStyles.closeButton, closeButtonSxProps)}
          onClick={reset}
        >
          <CloseIcon
            {...closeIconProps}
            sx={deepmerge(searchBarStyles.closeButtonIcon, closeIconSxProps)}
          />
        </IconButton>
        <InputBase
          className={`popupType-${popupType} VuiSearchPopupContent-searchBarInput`}
          fullWidth
          placeholder={t("Search")}
          onChange={onChange}
          inputRef={searchInputRef}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end">
              <CrossIcon onClick={clearSearchValue} />
            </InputAdornment>
          }
          {...inputProps}
          sx={deepmerge(searchBarStyles.searchInput, inputSxProps)}
        />
      </Box>
      {/* End of SearchBar */}

      {/* Category Quick Search */}
      {/* //TODO:: Add Category Quick Search later */}
      {/* End of Category Quick Search */}

      {/* SearchResult */}
      <SearchResult
        {...searchResultProps}
        popupType={popupType}
        items={searchResultItems}
        onSelect={onSelectResult}
      />
      {/* End of SearchResult */}

      {showOnscreenKeyboard && (
        <SearchKeyboard
          {...searchKeyboardProps}
          value={searchValue}
          onChange={onChangeKeyboard}
        />
      )}
    </SearchBasePopup>
  )
}
